export default __webpack_public_path__ + "static/media/back-icon.4951f9d2.svg";